// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__30KW9","resendInfoText":"OnGoingPaymentBox_resendInfoText__2zMz2"};